import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Consents = loadable(() => import('./PSD2Consents'), {
  fallback: <Loader />,
});
